<template>
  <footer class="app-preview-footer">
    <div class="app-preview-footer-container" :class="footerClasses">
      <div class="app-preview-footer-panel">
        <div class="app-preview-footer-header" @click="togglePanel">
          <platform-selector class="dashboard-preview-platform" :active="platform" mini></platform-selector>
          <h2 class="app-preview-footer-title">{{title}}</h2>
          <button type="button" class="app-preview-footer-toggle">
          </button>
        </div>

        <div class="app-preview-footer-content">
          <slot />
        </div>
      </div>

      <div class="app-preview-footer-actions">
        <slot name="footer-actions"></slot>
      </div>
    </div>

    <transition name="app-footer-preview-backdrop">
      <div class="app-preview-footer-backdrop" v-if="showPanel" @click="togglePanel"></div>
    </transition>
  </footer>
</template>

<script>
  export default {
    name: 'AppPreviewFooter',
    props: {
      title: String,
      openPanel: Boolean
    },
    inject: ['previewData'],
    data: () => ({
      showPanel: false,
      platform: 'desktop'
    }),
    computed: {
      footerClasses () {
        return {
          'is-active': this.showPanel
        }
      }
    },
    created () {
      this.$event.on('update-platform', this.updatePlatform)
    },
    beforeDestroy () {
      this.$event.off('update-platform', this.updatePlatform)
    },
    watch: {
      openPanel (check) {
        this.showPanel = check
      }
    },
    methods: {
      togglePanel () {
        this.showPanel = !this.showPanel
      },
      updatePlatform (platform) {
        this.platform = platform
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '~stylesheets/meta.scss';
  .dashboard-preview-platform {
    position: absolute;
    top: -12px;
    right: 24px;
  }

  .app-preview-footer {
    min-height: 48px;
    position: relative;
  }

  .app-preview-footer-container {
    position: relative;
    z-index: 2;

    &.is-active {
      .app-preview-footer-panel {
        transform: translate3d(0, -100%, 0);
      }

      .app-preview-footer-header {
        background-color: $color-marine;
        color: #fff;
      }

      .app-preview-footer-toggle {
        transform: rotateX(180deg);

        path {
          fill: $color-darker-grey;
        }
      }

      .app-preview-footer-content {
        opacity: 1;
        transform: translate3d(0, 0, 0);
        backface-visibility: hidden;
      }

      .app-preview-footer-actions {
        transform: translate3d(0, 0, 0);
      }

      .app-preview-footer-backdrop {
        opacity: 1;
        pointer-events: auto;
      }
    }
  }

  .app-preview-footer-panel {
    height: 280px;
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    z-index: 2;
    background-color: #fff;
    transition: transform .3s $transition-ease-out;
  }

  .app-preview-footer-header {
    min-height: 48px;
    padding: 0 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    position: relative;
    z-index: 2;
    background-color: $color-marine;
    color: #fff;
    transition: .3s $transition-ease-out;
    transition-property: color, background-color;
    will-change: color, background-color;
  }

  .app-preview-footer-title {
    margin: 0;
    font-size: 17px;
    font-weight: 400;
    line-height: 1.35em;
  }

  .app-preview-footer-toggle {
    @include clear-button;
    width: 16px;

    path {
      fill: #fff;
    }
  }

  .app-preview-footer-content {
    padding: 16px;
    display: flex;
    flex-direction: column;
    flex: 1;
    opacity: 0;
    transition: .5s $transition-ease-out;
    transition-property: transform, opacity;
    will-change: transform, opacity;
    height: 100%;
  }

  .app-preview-footer-actions {
    min-height: 48px;
    display: flex;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    z-index: 3;
    transform: translate3d(0, 100%, 0);
    transition: transform .4s $transition-ease-out;
    will-change: transform;

    .button {
      flex: 1 1 100%;
      border-radius: 0;
      text-transform: uppercase;

      .svg-image {
        path {
          fill: #fff;
        }
      }
    }
  }

  .app-preview-footer-backdrop {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    transition: opacity .4s $transition-ease-out;
    will-change: opacity;
  }

  .app-footer-preview-backdrop-enter,
  .app-footer-preview-backdrop-leave-active {
    opacity: 0;
  }
</style>
